import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';

import { ContactSearchService } from '../../../services/contacts/contact-search.service';

@Component({
  selector: 'app-author-search',
  templateUrl: './author-search.component.html',
  styleUrls: ['./author-search.component.css'],
})
export class AuthorSearchComponent implements OnInit, OnChanges {
  authorSearchTerm: string;

  @Input() include_item: boolean = false;
  @Input() authorId: number | undefined;
  @Input() small_input: boolean = false;
  @Input() editable: boolean = true;
  @Input() placeholder: string;
  @Output() author_id: EventEmitter<string> = new EventEmitter();
  @Input() select_only: boolean = false;
  @Output() author: EventEmitter<any> = new EventEmitter();
  @Output() clearAuthor: EventEmitter<any> = new EventEmitter();

  constructor(private contactSearchService: ContactSearchService) {}

  // Component lifecycle events

  ngOnInit() {}

  ngOnChanges(changes: any) {
    if (changes.authorId && changes.authorId.currentValue && !this.select_only)
      this.contactSearchService.getContactInfo(this.authorId!).then((response_json) => {
        this.authorSearchTerm = response_json.name;
      });
    else if (this.select_only) this.authorSearchTerm = '';
  }

  // Component methods

  clearSelectedAuthor(): void {
    this.authorId = undefined;
    this.authorSearchTerm = '';
    this.clearAuthor.emit('clearAuthor');
  }

  authorSearchOnSelect(item: any): void {
    if (this.include_item) this.authorId = item.id;
    else this.authorId = item;
    if (this.select_only) {
      let scope = this;
      this.author.emit(item);
      window.setTimeout(function () {
        scope.authorSearchTerm = '';
      }, 100);
    } else if (this.include_item) {
      this.author.emit(item);
      this.author_id.emit(String(item.id));
    } else this.author_id.emit(String(item));
  }
}
